import { useContext } from 'react';
import { IsAuthenticatedContext } from '../context';
import { NotWrappedError } from '../functions';
var useIsAuthenticated = function () {
    var context = useContext(IsAuthenticatedContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useIsAuthenticated;
//# sourceMappingURL=useIsAuthenticated.js.map